let ListOfDocuments = [
    {
        "Group": "FormI983",
        "DocumentType": "I983",
        "DisplayName": "I-983",
        "UploadMultiple": false,
        "CanESign": false,
        "CanBeApproved": true,
        "DocumentStatus": "Initiate",
        "Metadata": [{
                "DataType": "System.DateTime",
                "Key": "SignedDate",
                "DisplayName": "Completed/Signed Date",
                "IsVisible": true,
                "IsRequired": true
            },
            {
                "DataType": "System.String",
                "Key": "DocumentUrl",
                "DisplayName": "Document Url",
                "IsVisible": false,
                "IsRequired": true
            }
        ],
        "MetadataValues": [],
        "EntityType": "I983",
        "DocTypeToolTip": "Please upload  I-983 Copy along with its Signed Date.",
        "LCAId": null,
        "DocumentId": null,
        "DisplayText": null,
        "IsDocumentRequired": null,
        "H1BId": null,
        "RequestDocStatus": null,
        "IsDocumentFreezed": null,
        "IsESignCompleted": null,
        "ShowTextEditor": null,
        "IsPrivate": false
    }
];

export default ListOfDocuments


// WEBPACK FOOTER //
// ./src/components/ESSProfile/FormI983/RequestModel.js